import { Header2, Paragraph2, LinkButton, Close16 as IconClose } from '@cian/ui-kit';

import * as React from 'react';
import classNames from 'classnames';

import * as styles from './styles.css';

interface ICoworkingModalAdMini {
  className?: string;
  onClose(event: React.SyntheticEvent<HTMLButtonElement>): void;
}

export const CoworkingModalAdMini: React.FC<ICoworkingModalAdMini> = ({ className, onClose }) => (
  <div className={classNames(styles['root'], className)}>
    <button type="button" className={styles['button-close']} onClick={onClose}>
      <IconClose />
    </button>
    <div className={styles['header']} />
    <div className={styles['content']}>
      <div className={styles['content-item']}>
        <Header2>Коворкинги теперь на Циан</Header2>
      </div>
      <div className={styles['content-item']}>
        <Paragraph2>Wi-Fi? Принтер? Парковка? Всё необходимое уже включено в стоимость</Paragraph2>
      </div>
      <div className={styles['link']}>
        <LinkButton
          size="XS"
          href="https://www.cian.ru/cat.php?coworking_offer_type%5B0%5D=1&deal_type=rent&engine_version=2&offer_type=offices&office_type%5B0%5D=1&region=1"
        >
          Посмотреть коворкинги
        </LinkButton>
      </div>
    </div>
  </div>
);
CoworkingModalAdMini.displayName = 'CoworkingModalAdMini';
